
export default {
  formActions: {
    addPlaceInput: 'Add place input',
    clearRoute: 'Clear route',
    reverseRoute: 'Reverse route',
    roundTrip: 'Round trip',
    toggleRoundTrip: 'Toggle round trip'
  }
}
